import APIClient from '@/shared/http/clients/api'

const resourceName = 'campanhaenvio'
const APICore = process.env.APIBaseURLCore

const GetAll = (data = {}, config = {}) => APIClient.get(`${APICore}/${resourceName}/?sort=name,asc&size=500`, data, config)
const GetAllPaging = (limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?page=${index}&size=${limit}`, config)
const GetById = (id, config = {}) => APIClient.get(`${APICore}/${resourceName}/${id}`, config)
const Create = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/`, data, config)
const Update = (data = {}, config = {}) => APIClient.put(`${APICore}/${resourceName}/${data.id}`, data, config)
const Delete = (id, config = {}) => APIClient.delete(`${APICore}/${resourceName}/${id}`, config)
const Search = (campanhaId = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/?campanhaId=${campanhaId}&page=${index}&size=${limit}`, config)
const SendTest = (data = {}, config = {}) => APIClient.post(`${APICore}/${resourceName}/envio-teste/`, data, config)
const Report = (campanhaId = {}, limit, index, config = {}) => APIClient.get(`${APICore}/${resourceName}/report/?campanhaId=${campanhaId}`, config)

const CampaignSentRepository = {
  GetAll,
  GetAllPaging,
  GetById,
  Create,
  Update,
  Delete,
  Search,
  SendTest,
  Report
}

export default CampaignSentRepository



// WEBPACK FOOTER //
// ./src/shared/http/repositories/campaign/campaignsent.js